import { render, staticRenderFns } from "./HeaderForNewItem.vue?vue&type=template&id=4f88f53b"
import script from "./HeaderForNewItem.vue?vue&type=script&lang=js"
export * from "./HeaderForNewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports